import React from 'react';
import Form from 'react-bootstrap/esm/Form';
import { useDispatch, useSelector } from 'react-redux';
import { IReducer } from '../../../../../../../../../../redux/configureStore';
import { SetInitialPeriodOption } from '../../../../../../../../../../redux/fetchActions/legadoPage/transferApp';

function SetInitialPeriod() {
  const dispatch = useDispatch();
  const transfersFilterState = useSelector(
    (reducer: IReducer) => reducer.transfersFilterApp
  );

  const handleInputChange = (event) => {
    let { value } = event.target;
    value = value.replace(/\D/g, '');

    if (value.length > 2) {
      const hours = parseInt(value.substr(0, 2), 10);
      const minutes = parseInt(value.substr(2, 2), 10);
      const seconds = parseInt(value.substr(4, 2), 10);

      if (hours > 23) {
        value = '23';
      }

      if (minutes > 59) {
        value = `${value.substr(0, 2)}59`;
      }

      if (seconds > 59) {
        value = `${value.substr(0, 4)}59`;
      }

      value = `${value.substr(0, 2)}:${value.substr(2, 2)}:${value.substr(
        4,
        2
      )}`;
    }

    dispatch(SetInitialPeriodOption(value));
  };

  return (
    <Form.Control
      type="text"
      value={transfersFilterState.time.from}
      onChange={handleInputChange}
    />
  );
}

export default SetInitialPeriod;
